import axios from 'axios';


export default {
    userData:(userId)=>{
        return axios.get(`admin/detalle/usuario/${userId}`);
    },
    blockUser:(data)=>{
        return axios.post(`admin/bloquear/usuario`,data);
    },
    unblockUser:(data)=>{
        return axios.post(`admin/desbloquear/usuario`,data);
    },
    cancelSuscription:(data)=>{
        return axios.post(`admin/cancelar/suscripcion`,data);
    },
    deleteUser:(idUser)=>{
        return axios.delete(`admin/eliminar/usuario/${idUser}`);
    },
    updateCompanyInfo:(data)=>{
        return axios.post(`admin/actualizar/equipo`,data);
    },
    resetPassword:(data)=>{
        return axios.post(`admin/restablecer/contrasena`,data);
    },
    createNewUser:(data)=>{
        return axios.post(`admin/crear/usuario`,data);
    },
    addMemberToTeam:(data)=>{
        return axios.post(`admin/invitar/usuario`,data);
    },
    makeUserAdminTeam:(data)=>{
        return axios.post(`admin/hacer/dueno`,data);
    },
    deleteUserFromTeam:(data)=>{
        return axios.post(`admin/eliminar/miembro`,data);
    },
    resetEmailPassword:(data)=>{
        return axios.post(`admin/restablecer/contrasena/`, data);
    }

}